import { MnoProfile, User } from '@/apis/core';

const UserKey = 'user';
const ProfileKey = 'profile';

export const saveUser = (user: User) => {
  localStorage.setItem(UserKey, JSON.stringify(user));
};

export const restoreUser = () => {
  const value = localStorage.getItem(UserKey);
  return value ? (JSON.parse(value) as User) : undefined;
};

export const saveProfile = (profile: MnoProfile) => {
  localStorage.setItem(ProfileKey, JSON.stringify(profile));
};

export const restoreProfile = () => {
  const value = localStorage.getItem(ProfileKey);
  return value ? (JSON.parse(value) as MnoProfile) : undefined;
};
